import httpClient from './httpClient'

const BudgetRequestApi = {
  async search(query, pageSize, pageNo) {
    try {
      const res = await httpClient.post('/request/budget/search', {
        query: query,
        pageSize,
        pageNo,
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async create({
    insertionOrderId,
    insertionOrderBudgetId,
    budget,
    startTime,
    endTime,
  }) {
    try {
      const res = await httpClient.post(`/request/budget`, {
        insertionOrderId,
        insertionOrderBudgetId,
        budget,
        startTime,
        endTime,
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  },
  /**
   * @param {{budgetRequests: {
   *   insertionOrderId:numner;
   *   budget:number;
   *   startTime:string;
   *   endTime:string;
   * }[]}} budgetAddRequest
   */
  async createBulk(budgetAddRequest) {
    // 追加する予算のリストに異なるinsertionOrderIdが含まれていたらエラー
    if (
      !budgetAddRequest.budgetRequests.every(budgetAddRequestItem =>
        budgetAddRequest.budgetRequests.every(
          _budgetAddRequestItem =>
            _budgetAddRequestItem.insertionOrderId ===
            budgetAddRequestItem.insertionOrderId,
        ),
      )
    ) {
      throw new Error()
    }

    const insertionOrderId = budgetAddRequest.budgetRequests[0].insertionOrderId

    try {
      const res = await httpClient.post(
        `/request/budget/insertion_order/${insertionOrderId}/bulk`,
        budgetAddRequest,
      )
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  },
  async requestDeleteBudget({
    insertionOrderId,
    insertionOrderBudgetId,
    budget,
    startTime,
    endTime,
  }) {
    try {
      const res = await httpClient.post(`/request/budget/delete`, {
        insertionOrderId,
        insertionOrderBudgetId,
        budget,
        startTime,
        endTime,
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  },
  async edit({
    insertionOrderId,
    insertionOrderBudgetId,
    budget,
    startTime,
    endTime,
  }) {
    try {
      const res = await httpClient.post(`/request/budget`, {
        insertionOrderId,
        insertionOrderBudgetId,
        budget,
        startTime,
        endTime,
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  },
  async resubmit({
    insertionOrderBudgetRequestId,
    budget,
    startTime,
    endTime,
  }) {
    try {
      const res = await httpClient.post(`/request/budget/resubmit`, {
        insertionOrderBudgetRequestId,
        budget,
        startTime,
        endTime,
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  },
  /**
   * 承認/却下を行う
   */
  async update(id, { requestStatus, reason = '' }) {
    try {
      const res = await httpClient.put(`/request/budget/${id}`, {
        requestStatus,
        reason,
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  },

  /**
   * 申請取り消し
   */
  async cancel(id) {
    try {
      const res = await httpClient.delete(`/request/budget/${id}`)
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  },
}

export default BudgetRequestApi
